
const Footer = () => {
  return (
    <footer id="contato" className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-[#E18E37]">Aprenda Elétrica</h3>
            <p className="text-gray-400">
              Seu curso completo de instalações elétricas residenciais online.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#E18E37]">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a href="#inicio" className="text-gray-400 hover:text-[#E18E37] transition-colors">
                  Início
                </a>
              </li>
              <li>
                <a href="#sobre" className="text-gray-400 hover:text-[#E18E37] transition-colors">
                  Sobre o Curso
                </a>
              </li>
              <li>
                <a href="#curso" className="text-gray-400 hover:text-[#E18E37] transition-colors">
                  Conteúdo
                </a>
              </li>
              <li>
                <a href="#galeria" className="text-gray-400 hover:text-[#E18E37] transition-colors">
                  Galeria
                </a>
              </li>
              <li>
                <a href="#depoimentos" className="text-gray-400 hover:text-[#E18E37] transition-colors">
                  Depoimentos
                </a>
              </li>
              <li>
                <a href="#contato" className="text-gray-400 hover:text-[#E18E37] transition-colors">
                  Contato
                </a>
              </li> 
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Aprenda Elétrica Residencial. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
